import { X } from 'lucide-react';
import { useEffect, useRef, type PropsWithChildren } from 'react';
import { createPortal } from 'react-dom';

export function Modal({ title, onClose, children }: PropsWithChildren<{ title: string; onClose: () => void }>) {
  const modal = useRef<HTMLElement>(null);

  useEffect(() => {
    const previousFocus = document.activeElement instanceof HTMLElement ? document.activeElement : null;
    const previousOverflow = document.body.style.overflow;
    const closeOnEscape = (event: KeyboardEvent) => {
      if (event.key === 'Escape') onClose();
    };
    document.body.style.overflow = 'hidden';
    document.addEventListener('keydown', closeOnEscape);
    const frame = window.requestAnimationFrame(() => {
      if (document.activeElement === document.body) modal.current?.querySelector<HTMLElement>('button, input, select, textarea, a[href]')?.focus();
    });
    return () => {
      window.cancelAnimationFrame(frame);
      document.body.style.overflow = previousOverflow;
      document.removeEventListener('keydown', closeOnEscape);
      previousFocus?.focus();
    };
  }, [onClose]);

  return createPortal(
    <div className="modal-backdrop" role="presentation">
      <div className="modal-backdrop__dismiss" role="presentation" onMouseDown={onClose} />
      <section ref={modal} className="modal" role="dialog" aria-modal="true" aria-labelledby="modal-title">
        <header><h2 id="modal-title">{title}</h2><button className="icon-button" onClick={onClose} aria-label="Close dialog"><X /></button></header>
        {children}
      </section>
    </div>,
    document.body,
  );
}
